// copied from packages/core/src/hosted-form/hosted-field-type.ts

enum HostedFieldType {
    CardCode = 'cardCode',
    CardCodeVerification = 'cardCodeVerification',
    CardExpiry = 'cardExpiry',
    CardName = 'cardName',
    CardNumber = 'cardNumber',
    CardNumberVerification = 'cardNumberVerification',
    CardExpiryVerification = 'cardExpiryVerification',
}

export default HostedFieldType;
